import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "result absolute-fill"
}
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "result-fade" }, {
    default: _withCtx(() => [
      (_ctx.isWarningVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "bg absolute-fill",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.isWarningClosed = true))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("i", {
                class: "bi bi-x-lg",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (this.isWarningClosed = true))
              }),
              (this.$route.query.success !== undefined)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[2] || (_cache[2] = _createElementVNode("p", null, " Поздравляем с приобретением пропуска! ", -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("p", null, " Информация о заказе отправлена на e-mail. ", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", null, " Большое спасибо за поддержку проекта! ", -1))
                  ], 64))
                : (this.$route.query.error !== undefined)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[5] || (_cache[5] = _createElementVNode("p", null, " Похоже, произошла какая-то ошибка при оплате. ", -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("p", null, " Попробуем ещё раз? ", -1))
                    ], 64))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}